class ProductContentSwitcher extends HTMLElement {
  constructor() {
    try {
      super();
      this.mainProduct = JSON.parse(atob(this.dataset.mainProduct));
      const rawProducts = atob(this.dataset.products);

      this.products = JSON.parse(rawProducts);
      this.whatsIncludedSections = {};

      // Initialize whatsIncludedSections map
      this.products.forEach((block) => {
        // Use icon_set as the identifier instead of id
        const identifier = block.icon_set;

        // Find the section using icon_set as identifier
        const section = this.querySelector(`[data-whats-included="${identifier}"]`);

        if (section) {
          const productHandle = block.product;
          if (productHandle) {
            this.whatsIncludedSections[productHandle] = section;
          }
        }
      });

      this.init();
    } catch (error) {
      console.error('Error in ProductContentSwitcher constructor:', error);
    }
  }

  init() {
    document.addEventListener('click', (event) => {
      const productButton = event.target.closest('[data-product-handle]');
      if (productButton) {
        const productHandle = productButton.dataset.productHandle;
        const blockId = productButton.dataset.blockId;
        this.updateContent(productHandle, blockId);
      }
    });
  }

  updateContent(productHandle, blockId) {
    try {
      // Find the selected product block
      const selectedBlock = this.products.find((block) => block.product === productHandle);

      if (!selectedBlock) {
        console.warn('No block found for product:', productHandle);
        return;
      }

      // Update media gallery using the product_data we passed from Liquid
      if (selectedBlock.product_data && selectedBlock.product_data.media) {
        this.updateMediaGallery(selectedBlock.product_data.media);
      } else {
        console.warn('No media data found in selected block:', selectedBlock);
      }

      // Debug all what's included sections before toggling
      const identifier = selectedBlock.icon_set;

      // Hide all sections first
      this.products.forEach((block) => {
        if (block.icon_set) {
          const section = this.querySelector(`[data-whats-included="${block.icon_set}"]`);
          if (section) {
            section.classList.add('tw-hidden');
          }
        }
      });

      // Show the selected section
      const selectedSection = this.querySelector(`[data-whats-included="${identifier}"]`);
      if (selectedSection) {
        selectedSection.classList.remove('tw-hidden');
      }

      // Dispatch event for variant selector
      const productChangeEvent = new CustomEvent('product:changed', {
        detail: {
          productHandle,
          blockId,
          selectedBlock,
        },
        bubbles: true,
      });
      this.dispatchEvent(productChangeEvent);
    } catch (error) {
      console.error('Error in updateContent:', error);
    }
  }

  updateMediaGallery(media) {
    const gallery = this.querySelector('product-media-gallery');
    if (!gallery) {
      console.warn('No gallery element found');
      return;
    }

    // Update main slider
    const mediaHtml = media
      .map(
        (item) => `
      <div class="embla__slide">
        ${
          item.media_type === 'image'
            ? `<img
              src="${item.src}"
              width="100%"
              height="100%"
              class="tw-block tw-w-full tw-h-full tw-object-cover tw-max-h-[88vh]"
              alt="${item.alt || ''}"
              loading="lazy"
            >`
            : item.html
        }
      </div>
    `
      )
      .join('');

    // Update thumbnails
    const thumbnailsHtml = `
      <ul class="tw-flex tw-justify-center tw-gap-xs tw-mt-sm">
        ${media
          .map(
            (item, index) => `
          <li>
            <button
              data-index="${index}"
              class="${
                index === 0 ? 'tw-ring-2 tw-ring-[red]' : ''
              } tw-w-[60px] tw-h-[60px] tw-overflow-hidden tw-rounded-sm tw-transition-all tw-duration-300 hover:tw-ring-2 hover:tw-ring-primary-grey-mid"
            >
              ${
                item.media_type === 'image'
                  ? `<img
                      src="${item.preview_image.src}"
                      alt="${item.alt || ''}"
                      width="100%"
                      height="100%"
                      loading="lazy"
                      class="tw-block tw-w-full tw-h-full tw-object-cover"
                    />`
                  : `<img
                      src="${item.preview_image.src}"
                      alt="${item.alt || ''}"
                      width="100%"
                      height="100%"
                      loading="lazy"
                      class="tw-block tw-w-full tw-h-full tw-object-cover"
                    />`
              }
              <span class="tw-sr-only">${item.alt || 'Slide'}</span>
            </button>
          </li>
        `
          )
          .join('')}
      </ul>
    `;

    const container = gallery.querySelector('.embla__container');
    const thumbnailNav = gallery.querySelector('.thumbnail-nav');

    if (container && thumbnailNav) {
      container.innerHTML = mediaHtml;
      thumbnailNav.innerHTML = thumbnailsHtml;

      // Reset and reinitialize the gallery
      gallery.dispatchEvent(new CustomEvent('gallery:reinit'));
    } else {
      console.warn('Gallery elements not found:', { container, thumbnailNav });
    }
  }

  getImageUrl(gid) {
    try {
      //
    } catch (error) {
      console.error('Error getting image URL:', {
        error: error.message,
        stack: error.stack,
        gid,
      });
    }
  }
}

customElements.define('product-content-switcher', ProductContentSwitcher);

export default ProductContentSwitcher;
